import React from 'react';
import { Button, Dropdown, Layout, Space } from 'antd';
import { DownOutlined, LogoutOutlined, TeamOutlined, UserOutlined } from '@ant-design/icons';
import LanguageSelect from './LanguageSelect';
import ThemeSelect from './ThemeSelect';
import NotificationCentre from './NotificationCentre';
import { useI18n } from '../i18n';
import { brandSemantic } from '../config/brand';

const { Header } = Layout;

export default function AppHeader({
  currentUser,
  language,
  setLanguage,
  colorPalette,
  setColorPalette,
  setCurrentView,
  handleLogout,
  notifications,
  onMarkNotificationRead,
  onMarkAllNotificationsRead,
  onNotificationNavigate,
}) {
  const { t } = useI18n();
  const userMenu = {
    items: [
      {
        key: 'personalProfile',
        icon: <UserOutlined />,
        label: t('Personal Profile'),
        onClick: () => setCurrentView('personalProfile'),
      },
      ...(currentUser?.role === 'admin' ? [{
        key: 'users',
        icon: <TeamOutlined />,
        label: t('User Management'),
        onClick: () => setCurrentView('users'),
      }] : []),
      {
        type: 'divider',
      },
      {
        key: 'logout',
        icon: <LogoutOutlined />,
        label: t('Logout'),
        onClick: handleLogout,
      },
    ],
  };

  return (
    <Header style={{
      background: brandSemantic.surface,
      padding: '0 24px',
      borderBottom: `1px solid ${brandSemantic.borderSecondary}`,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      height: '64px',
      position: 'fixed',
      top: 0,
      left: 104,
      right: 0,
      zIndex: 100,
      boxShadow: '0 1px 3px rgba(15, 23, 42, 0.06)',
    }}>
      <div style={{ display: 'flex', alignItems: 'center', minWidth: 0 }}>
        <img src="/PB-logo-mocca-web.png" alt="Profilbureauet" style={{ height: '50px', width: 'auto' }} />
      </div>
      <div style={{ display: 'flex', alignItems: 'flex-start', gap: 16 }}>
        <ThemeSelect value={colorPalette} onChange={setColorPalette} width={190} />
        <LanguageSelect value={language} onChange={setLanguage} width={150} />
        <NotificationCentre
          notifications={notifications}
          currentUser={currentUser}
          onMarkRead={onMarkNotificationRead}
          onMarkAllRead={onMarkAllNotificationsRead}
          onNavigate={onNotificationNavigate}
          t={t}
        />
        <Dropdown menu={userMenu} trigger={['click']}>
          <Button type="text" style={{ height: 'auto', padding: '2px 8px 0', display: 'flex', alignItems: 'flex-start' }}>
            <Space align="start" size={8}>
              <div style={{ textAlign: 'right', lineHeight: 1.2 }}>
                <div style={{ fontWeight: 600, fontSize: 14 }}>{currentUser?.name}</div>
                <div style={{ fontSize: 11, color: brandSemantic.textSecondary, textTransform: 'lowercase' }}>
                  {currentUser?.role ? t(currentUser.role) : ''}
                </div>
              </div>
              <DownOutlined style={{ fontSize: 11, marginTop: 6 }} />
            </Space>
          </Button>
        </Dropdown>
      </div>
    </Header>
  );
}
